export default {
  ticket: {
    list: [],
    total: 0
  },

  crrTicket: {}
}
